import { render, staticRenderFns } from "./ImageCreate.vue?vue&type=template&id=e7c9de04"
import script from "./ImageCreate.vue?vue&type=script&lang=js"
export * from "./ImageCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports